export const sx = {
    root: {
        '&.isLoading':{
            opacity:'.5',
            pointerEvents:'none'
        }
    }
}